import sectionImage from "../../../assets/homePageV2/problems.png";
import { problemasMargemContent as c } from "./content";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";

export function Problems() {
  return (
    <section
      className="home-page-v2__section home-page-v2__section--margem"
      style={{
        backgroundImage: `url(${sectionImage})`,
        height: "100%",
        minHeight: 700,
        backgroundSize: "cover"
      }}
    >
      <div className="home-page-v2__section-inner home-page-v2__margem-layout">
        <div className="home-page-v2__margem-card">
          <h2 id="problemas-margem-heading">{c.heading}</h2>
          <p>{c.intro}</p>
        </div>

        <div className="home-page-v2__margem-list">
          <ul className="pill-list">
            {c.items.map((text) => (
              <li key={text}>
                <span className="home-page-v2__pill-list-icon" aria-hidden>
                  <BackIcon width={16} height={16} />
                </span>
                <span>
                  {text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
